<template>
  <div>
    <div class="d-flex justify-content-between tw-mb-6 tw-items-start">
      <div class="d-flex justify-content-between tw-items-center">
        <ProfileInfoCard :global-id="userAccount.globalId" class="m-r-15">
          <img :src="userAccount.picture" class="profile-image img-circle" />
        </ProfileInfoCard>
        <div class="tw-text-base">
          <WdsStack align-center>
            <span class="tw-font-medium">
              <a v-if="userAccount?.primaryProfile" :href="userAccount.primaryProfile.url">
                {{ userAccount.name }}
              </a>
              <span v-else>
                {{ userAccount.name }}
              </span>
            </span>
            <span
              v-if="!isRecruiter(userAccount) && userAccount.liked"
              v-tooltip="$t('You have previously saved this freelancer as a favorite.')"
              class="tw-ml-3 f-15 iblock c-orange-500 liked"
            >
              <span class="glyphicon glyphicon-heart" aria-hidden="true"></span>
            </span>
          </WdsStack>
          <div v-if="isRecruiter(userAccount)" class="tw-text-gray-700 truncate-info">
            {{ $t('Recruiter') }}
          </div>
          <div v-if="!isRecruiter(userAccount)">
            <div v-if="userAccount?.jobTitle" class="tw-text-gray-700 truncate-info">
              {{ userAccount.jobTitle }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <WdsLabel v-if="isClosed" error subtle class="tw-whitespace-nowrap">
          {{ $t('Ended conversation') }}
        </WdsLabel>
        <WdsLabel
          v-else-if="!isRecruiter(userAccount) && lastOffer"
          primary
          subtle
          class="tw-whitespace-nowrap"
        >
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <CurrencyDisplay
            :show-converted-rates-by-default="
              Boolean($store.state.user.automatic_currency_conversion)
            "
            :currency-code="yjob.currency"
            :converted-currency-code="user.currency ? user.currency : 'Undefined'"
            :rate="Number(lastOffer.rate)"
            @applying-currency-code="currencyCodeChanged"
          />
          <span>&nbsp;{{ lastOffer.currency }}</span>
          <span>&nbsp;{{ lastOffer.ratetypeNameSlash }}</span>
        </WdsLabel>
        <WdsStack
          v-else-if="isRecruiter(userAccount) && userAccount?.pitchedOffers?.data?.length"
          align-center
        >
          <WdsAvatarGroup
            class="tw-mr-4"
            sm
            :avatars="getAvatars(userAccount.pitchedOffers.data)"
            :max-avatars="6"
          />
          <WdsLabel primary subtle>
            {{ $tc(':count submission', userAccount.pitchedOffers.data.length) }}
          </WdsLabel>
        </WdsStack>
      </div>
    </div>
    <div class="clear" />
  </div>
</template>

<script>
import { WdsLabel, WdsStack, WdsAvatarGroup } from '@worksome/wds-components'
import gql from 'graphql-tag'
import { BidStatus } from '@/utils/enum'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { graphqlFragmentValidator } from '@/utils/propValidation'
import { getAvatarPath } from '@/utils/avatar'

const JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_YJOB = gql`
  fragment JobPageDialogsItemHeaderFragmentForYjob on Yjob {
    currency
  }
`

const JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG = gql`
  fragment JobPageDialogsItemHeaderFragmentForDialog on Dialog {
    dialogType
    lastOffer {
      status
      rate
      currency
      ratetypeNameSlash
    }
    freelancer {
      __typename
      localId
      globalId
      picture
      liked
      name
      jobTitle
      primaryProfile {
        url
      }
    }
    recruiter {
      __typename
      localId
      globalId
      picture
      name
      primaryProfile {
        url
      }
      pitchedOffers(yjobId: $yjobId, status: [OPEN, ACCEPTED]) {
        data {
          freelancer {
            globalId
            hasPicture
            picture
            initials
          }
        }
      }
    }
  }
`

export default {
  components: {
    ProfileInfoCard,
    WdsLabel,
    WdsStack,
    WdsAvatarGroup,
  },
  props: {
    userAccount: {
      type: Object,
      default: () => ({}),
    },
    lastOffer: {
      type: Object,
      default: () => ({}),
    },
    yjob: {
      type: Object,
      required: true,
      validator: graphqlFragmentValidator(JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_YJOB),
    },
    dialogType: {
      type: String,
      default: '',
    },
  },
  fragments: {
    yjob: JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_YJOB,
    dialog: JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG,
  },
  data: () => ({
    offerStatusEnum: BidStatus,
    currency: null,
  }),
  computed: {
    isClosed() {
      return this.dialogType.toLowerCase() === 'closed'
    },
  },
  mounted() {
    this.currency = this.yjob.currency
  },
  methods: {
    currencyCodeChanged(currencyCode) {
      this.currency = currencyCode || this.yjob.currency
    },
    isRecruiter(userAccount) {
      return userAccount?.__typename === 'Recruiter' || false
    },
    getAvatars(candidates) {
      return candidates.map((candidate) => ({
        path: getAvatarPath(
          candidate.freelancer.hasPicture ? candidate.freelancer.picture : undefined,
          candidate.freelancer.globalId,
        ),
        initials: candidate.freelancer.initials,
      }))
    },
  },
}
</script>
